import { render } from "./schoolDashboard.vue?vue&type=template&id=c9c5cbfa&scoped=true"
import script from "./schoolDashboard.vue?vue&type=script&lang=js"
export * from "./schoolDashboard.vue?vue&type=script&lang=js"

import "./schoolDashboard.vue?vue&type=style&index=0&id=c9c5cbfa&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9c5cbfa"]])

export default __exports__